import i18n from "../../../../i18n"

const StoreAddress = ({store}) => {
    return (
        <div>
            <h5>{i18n.t('Adres')}</h5>
            <div>{store.address}</div>
            <div>{store.zipcode}, {store.city}</div>
            <div>{store.country}</div>
            <div><a href={`tel:${store.phone}`}>{store.phone}</a></div>
            <div><a href={`mailto:${store.info_email}`}>{store.info_email}</a></div>
            {store.conditions && <div> <a href={store.conditions} target="_blank">{i18n.t('Algemene Voorwaarden')}</a></div>}
        </div>
    )
}

export default StoreAddress